<template>
  <div id="content">
    <div id="productdetail">
    <div class="nav_prod" v-if="$i18n.locale == 'en'">
       Position: <a href="/#/product"><span>Product</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.bigclassid_name_en}}</span></a> > <span>{{porduct.prod_enname}}</span>
   </div>
    <div class="nav_prod" v-else>  
      你当前的位置：<a href="/#/product"><span>产品展示</span></a> > <a :href="'/#/product/' + porduct.bigclassid"><span>{{porduct.bigclassid_name}}</span></a> > <span>{{porduct.prod_name}}</span>
   
     </div>
      
      <div class="product_1">
        <div class="product_101" v-if="$i18n.locale == 'en'">
          {{ porduct.prod_enname }}
        </div>
        <div v-else class="product_101">{{ porduct.prod_name }}</div>
        <div class="prod le">
          <div
            class="tempWrap"
          >
            <ul
            >
             <li v-for="p in porduct.images" :key="p" style="height: 750px">
                <img
                  :src="p"
                />
              </li>
            </ul>
          </div>
        </div>
        <div class="hd fr">
          <ul>
             <li v-for="p in porduct.images" :key="p" >
              <img
                  :src="p"
              />
            </li>
          </ul>
        </div>
        <div class="clear"></div>
      </div>
      <div class="product_102">
        <div v-if="$i18n.locale == 'en'" class="product_103 le">PROD INFO：</div>
        <div v-else class="product_103 le">产品详情</div>
        <span v-if="$i18n.locale == 'en'">NO：{{porduct.prod_numbers}}</span>
        <span v-else >商品货号：{{porduct.prod_numbers}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">NAME：{{porduct.prod_enname}}</span>
        <span v-else >商品品名：{{porduct.prod_name}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">COLOR：{{porduct.prod_color_en}}</span>
        <span v-else >颜色选择：{{porduct.prod_color}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">STYLE：{{porduct.prod_style_en}}</span>
        <span v-else >款式选择：{{porduct.prod_style}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">MADE：{{porduct.prod_made_en}}</span>
        <span v-else >商品产地：{{porduct.prod_made}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">MATERIAL{{porduct.prod_material_en}}</span>
        <span v-else >商品材质：{{porduct.prod_material}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">AGE：{{porduct.prod_age_en}}</span>
        <span v-else >适用年龄：{{porduct.prod_age}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">BOX SIZE：{{porduct.prod_box_en}}</span>
        <span v-else >外箱规格：{{porduct.prod_box}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">SIZE：：{{porduct.prod_inner_en}}</span>
        <span v-else >产品规格：{{porduct.prod_inner}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">COUNT：{{porduct.prod_box_num_en}}</span>
        <span v-else >装箱数量：{{porduct.prod_box_num}}</span>
        <br/>
        <span v-if="$i18n.locale == 'en'">CONFIG：{{porduct.prod_info_en}}</span>
        <span v-else >产品配置：{{porduct.prod_info}}</span>
        <br/>
      </div>
    <div v-if="$i18n.locale == 'en'"  class="product_104"  v-html="porduct.prod_content_en">
    </div>
    <div  v-else  class="product_104" v-html="porduct.prod_content">
    </div>
    </div>
  </div>
</template>

<script>
import fetch from "@/utils/axios";
export default {
  components: {},
  name: "ProductDetail",
  data() {
    return {
      porduct: {},
    };
  },
  mounted() {
    // 使用
    const params = { id: this.$route.params.id }; // 参数
    fetch.post("/api/ApiProduct/Get", params).then(
      (res) => {
        this.porduct = res;
        setTimeout(function () {
          jQuery(".product_1").slide(
            {
              effect: "topLoop",
              mainCell: ".prod ul",
              autoPlay: true,
              interTime: 5500,
              vis: 1,
              scroll: 1,
              easing: "swing",
              trigger: "mouseover",
            },
            500
          );
        });
      },
      (error) => {
        alert(JSON.stringify(error));
      }
    );
  },
};
</script>

<style>
#productdetail {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.product_1 {
  width: 1400px;
  margin: 20px auto auto;
}
.product_101 {
  width: 100%;
  text-align: center;
  color: #333;
  font-size: 26px;
  line-height: 32px;
  margin-bottom: 20px;
}

.prod {
  width: 1000px;
  border: 1px #f5f5f5 solid;
  height: 750px;
  margin-left:40px ;
}
.prod li {
  width: 1000px;
}
.prod li img {
  display: block;
  overflow: hidden;
  width: 1000px;
  height: 750px !important;
}
.product_1 .hd {
  width: 350px;
}
.product_1 .hd li {
  text-align: right;
  margin-bottom: 10px;
  width: 314px;
  height: 225px;
  overflow: hidden;
}
.product_1 .hd li img {
  width: 300px;
  height: 223px;
  border: 1px #f5f5f5 solid;
}
.product_1 .hd li:hover {
  background: url(../images/prod01.jpg) no-repeat left center;
}
.product_1 .hd li:hover img {
  border: 1px #01a4e9 solid;
}
.product_1 .hd li.on {
  background: url(../images/prod01.jpg) no-repeat left center;
}
.product_1 .hd li.on img {
  border: 1px #01a4e9 solid;
}

.product_102 {
  text-align: left;
  width: 1320px;
  margin: 20px auto auto;
  font-size: 16px;
  color: #666;
  line-height: 30px;
  height: auto !important;
  min-height: 200px;
  _height: 200px;
}
.product_103 {
  width: 1320px;
  margin-bottom: 20px;
  font-weight: bold;
  margin: 20px auto auto;
}

.product_104 {
  width: 1320px;
  margin: 30px auto auto;
  padding-top: 18px;
  border-top: 1px #ccc dashed;
}
.nav_prod  {
  display: block;
  font-size: 14px;
  color: #333;
  width: 1300px;
  height: 32px;
  text-align: left;
  line-height: 32px;
  background: #e6e6e6;
  border-bottom: 3px #dbdbdb solid;
  margin: 30px auto auto;
  padding-left:30px ;
}
</style>



// WEBPACK FOOTER //
// src/components/ProductDetail.vue